export default {"src":"/_next/static/media/12.fd8906cc.svg","height":48,"width":47};